import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { logger } from 'redux-logger';
import { getNotificationsWatcher } from './sagas';
import appReducer from './reducers/appReducer';

// create the saga middleware
const sagaMiddleware = createSagaMiddleware();

// Logger devtools middleware
export const appStore = createStore(appReducer, compose(applyMiddleware(sagaMiddleware, logger)));

// run the saga
sagaMiddleware.run(getNotificationsWatcher);
